export class WorkspaceRoles {

  public workspaceRoles: any = [];

}

export class WorkspaceRoleForClient {

  public roleId: number;
  public roleSlug: string;
  public displayName: string;

}
